import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "ui-spinner",
    template: require('./ui-spinner.component.html'),
    styles: [require('./ui-spinner.component.css')]
})

export class UISpinnerComponent implements OnInit {
    constructor() {

    }

    @Input() loadingText: string;

    ngOnInit(): void {
        
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/ui-spinner.component.ts